module.exports = __webpack_public_path__ + "img/berry-trifle.c3879918.jpg";